// extracted by mini-css-extract-plugin
export default {"outerContainer":"WishlistIndex_outerContainer__KtP7b","innerContainer":"WishlistIndex_innerContainer__QUenn","create":"WishlistIndex_create__iboLE"};